var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isRead && _vm.isUpdate)?_c('div',{staticClass:"dot"},[_vm._v("1 "),_c('span',{staticClass:"tooltiptext"},[_vm._v("Neues Update verfügbar")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }